module.exports = __webpack_public_path__ + "static/media/register-new.56959336.svg";